<h2 class="text-center" translate>LOGGED_IN_USERS</h2>
<lib-filter-list [configService]="loggedInUserListConfigService"></lib-filter-list>